import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=51182e57&scoped=true"
import script from "./Dashboard.vue?vue&type=script&lang=ts"
export * from "./Dashboard.vue?vue&type=script&lang=ts"
import style0 from "./Dashboard.vue?vue&type=style&index=0&id=51182e57&prod&lang=css"
import style1 from "./Dashboard.vue?vue&type=style&index=1&id=51182e57&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.26_css-loader@6.11.0_webpack@5.104.1__lodash@4.17.21_pqvrgeoyoc7vllsfv3djl2e3nu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51182e57",
  null
  
)

export default component.exports